import { render, staticRenderFns } from "./404.vue?vue&type=template&id=f28793fa&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=f28793fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28793fa",
  null
  
)

export default component.exports